import React,{Component} from 'react'
import {BrowserRouter,Route,Link} from 'react-router-dom'
import { Layout, Menu} from 'antd';
import {
  DesktopOutlined,
  PieChartOutlined,
  FileOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';

const { Sider } = Layout;
const { SubMenu } = Menu;

export default class Slider extends Component{
    constructor(){
        super();
    }
    state = {
        collapsed: false,
      };
    
      onCollapse = collapsed => {
        console.log(collapsed);
        this.setState({ collapsed });
      };

    render(){
        return(
            <Sider collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
            <div className="logo" />
            <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
              <Menu.Item key="6" icon={<DesktopOutlined />}>
                <Link className="link-class" to="/categories">Manage Categories</Link>
              </Menu.Item>
              <Menu.Item key="7" icon={<DesktopOutlined />}>
                <Link className="link-class" to="/report">Upload Reports</Link>
              </Menu.Item>
              <Menu.Item key="2" icon={<DesktopOutlined />}>
                <Link className="link-class" to="/booking">Booking</Link>
              </Menu.Item>
              <SubMenu key="sub1" icon={<UserOutlined />} title="Test">
              <Menu.Item key="10"><Link className="link-class" to="/test">All Test</Link></Menu.Item>
                <Menu.Item key="3"><Link className="link-class" to="/test/add">Add Test</Link></Menu.Item>
              </SubMenu>
              <SubMenu key="sub4" icon={<UserOutlined />} title="Package">
              <Menu.Item key="100"><Link className="link-class" to="/package">All Packages</Link></Menu.Item>
                <Menu.Item key="30"><Link className="link-class" to="/package/add">Add Package</Link></Menu.Item>
              </SubMenu>
              <Menu.Item key="58" icon={<DesktopOutlined />}>
                <Link className="link-class" to="/prescription">Prescription</Link>
              </Menu.Item>
              <Menu.Item key="8" icon={<DesktopOutlined />}>
                <Link className="link-class" to="/queries">Queries</Link>
              </Menu.Item>
            </Menu>
          </Sider>
        )

    }
}